import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { Folder } from 'src/app/models/server/folder';
import { FolderSelectorComponent } from '../../../controls/folder-selector/folder-selector.component';
import { DialogMergeData } from './models/dialog-merge-data';

@Component({
    selector: 'app-merge',
    templateUrl: './merge.component.html',
    styleUrls: ['./merge.component.scss'],
    imports: [MatCardModule, FolderSelectorComponent, MatButtonModule, MatDialogClose]
})
export class MergeComponent {
    /**
     * Constructeur.
     * @param dialogRef
     * @param data
     */
    constructor(
        public dialogRef: MatDialogRef<MergeComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogMergeData
    ) {}

    /**
     * Appelée lorsque l'utilisateur sélectionne un dossier.
     * @param folder : dossier selectionné.
     */
    public onSelected(folder: Folder): void {
        this.data.targetFolder = folder;
    }

    /**
     * Appelée lorsque l'utilisateur clique sur le bouton 'Annuler'.
     */
    public cancel(): void {
        this.dialogRef.close();
    }
}
